import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';

export default function Landing(){
	return <>
		<h2>Welcome to Disco Trivialis, a game of betting against your friends in the rough-and-tumble world of categorical trivia!</h2>
	</>
}
